import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-blocks-simple")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-blocks-simple")),
  head: () => ({
    meta: [
      { title: "تحرير مبسَّط لبلوكات الهوم — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
